const {
  fetchBrowsingContext,
  getCookie,
  setCookie,
  shippingCountries,
} = window.BAO.Utils

function revealCookieBanner () {
  let timeout = 0
  if (!document.querySelector('#onetrust-consent-sdk')) timeout = 500
  setTimeout(() => {
    const onetrustConsentSdkEl = document.querySelector('#onetrust-consent-sdk')
    if (!onetrustConsentSdkEl) return

    onetrustConsentSdkEl.style.display = 'block'
  }, timeout)
}

/**
 * @note There's quite a lot of duplicated logic in this script. I've added `getLocationFromCookie`
 * and `getLocationFromUrl` methods which should in theory allow us to reduce a lot of duplication,
 * but I've not been able to replace and test each one. - DW
 */

/**
 * @typedef {Object} ShippingLocation
 *
 * @property {string} code
 * @property {string} currency
 * @property {string} name
 * @property {string} site
 */

function getRedirectUrl (site, region, currency) {
  const stores = {
    EU: 'https://the-frankie-shop-test-store.myshopify.com/',
    US: 'https://thefrankieshop.com',
  }

  const url = `${stores[site]}?region=${region}&currency=${currency}`

  return url
}

class ShippingLocationModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['select']
  }

  async connectedCallback () {
    super.connectedCallback()

    const {
      detected_values: { country: { handle = '' } } = {},
    } = await fetchBrowsingContext()
    this.detectedIso2Code = handle

    /** @type {HTMLSelectElement[]} */
    this.subscribedExternalSelectors = []

    this.connectExternalSelector(this.externalEls.footerSelect.element)
    this.connectExternalSelector(this.externalEls.mobileNavSelect.element)

    const stores = {
      EU: 'https://eu.thefrankieshop.com',
      US: 'https://thefrankieshop.com',
    }

    // If cookie is already set and is not the same store direct customer to cookie website

    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    } else if (getCookie('fs-geo')) {
      const cookie = JSON.parse(getCookie('fs-geo'))
      const cookieLocation = shippingCountries().filter(
        country => country.code === cookie.value,
      )

      const cookieSetStore = new URL(
        getRedirectUrl(
          cookieLocation[0].site,
          cookieLocation[0].code,
          cookieLocation[0].currency,
        ),
      )

      const region = new URL(window.location).searchParams.get('region')
      const queryLocation = shippingCountries().filter(
        country => country.code === region,
      )

      let querySetStore
      if (this.checkIfSearchParamsExist()) {
        querySetStore = new URL(
          getRedirectUrl(
            queryLocation[0].site,
            queryLocation[0].code,
            queryLocation[0].currency,
          ),
        )
      } else {
        querySetStore = {
          origin: '',
        }
      }

      if (cookieSetStore.origin !== window.location.origin) {
        if (querySetStore.origin !== window.location.origin) {
          window.location.href =
            cookieSetStore.origin +
            window.location.pathname +
            cookieSetStore.search
        }
      }
    }
    // End //

    if (this.checkIfSearchParamsExist()) {
      const region = new URL(window.location).searchParams.get('region')
      const location = shippingCountries().filter(
        country => country.code === region,
      )

      this.subscribedExternalSelectors.forEach(selector => {
        selector.value = location[0].code
      })

      if (
        new URL(
          getRedirectUrl(
            location[0].site,
            location[0].code,
            location[0].currency,
          ),
        ).origin !== new URL(window.location).origin
      ) {
        const storeLocalToCustomer = new URL(
          getRedirectUrl(
            location[0].site,
            location[0].code,
            location[0].currency,
          ),
        )
        window.location.href =
          storeLocalToCustomer.origin +
          window.location.pathname +
          storeLocalToCustomer.search
      }
    }

    if (new URL(window.location).pathname.includes('/products_preview')) return

    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.get('region')) {
      const stores = {
        EU: 'https://eu.thefrankieshop.com',
        US: 'https://thefrankieshop.com',
      }

      const region = new URL(window.location).searchParams.get('region')
      const location = shippingCountries().filter(
        country => country.code === region,
      )

      if (window.location.origin === stores[location[0].site]) {
        revealCookieBanner()

        setCookie(
          'fs-geo',
          JSON.stringify({
            value: location[0].code,
            name: location[0].name,
            site: location[0].site,
            currency: location[0].currency,
          }),
          14,
        )
      }
    } else if (this.checkIfCookieIsSet()) {
      this.assignValuesToFormElements(
        JSON.parse(getCookie('fs-geo')).value,
        JSON.parse(getCookie('fs-geo')).currency,
      )

      this.subscribedExternalSelectors.forEach(selector => {
        selector.value = JSON.parse(getCookie('fs-geo')).value
      })

      revealCookieBanner()

      return
    } else {
      const selectedCountry = shippingCountries().filter(
        country => country.code === this.detectedIso2Code,
      )

      if (stores[selectedCountry[0].site] !== window.location.origin) {
        this.showModal()
      }
    }

    this.buildShippingOptions(this.els.select.element)

    if (getCookie('fs-geo') !== '') return

    const selectedCountry = shippingCountries().filter(
      country => country.code === this.detectedIso2Code,
    )

    if (stores[selectedCountry[0].site] === window.location.origin) {
      revealCookieBanner()
    }

    this.assignValuesToFormElements(
      selectedCountry[0].code,
      selectedCountry[0].currency,
    )

    this.els.select.element.addEventListener(
      'change',
      this.onSelectChange.bind(this),
    )

    this.els.form.element.addEventListener(
      'submit',
      this.onSubmission.bind(this),
    )

    this.trapFocus()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.body,
      'shipping-location:request-connect',
      this.handleConnectRequest.bind(this),
    )
  }

  /** @param {CustomEvent<{ select: HTMLSelectElement }>} event */
  handleConnectRequest (event) {
    this.connectExternalSelector(event.detail.select)
  }

  /** @param {HTMLSelectElement} selector */
  connectExternalSelector (selector) {
    this.buildShippingOptions(selector)

    this.listeners.add(
      selector,
      'change',
      this.onExternalSelectChange.bind(this),
    )

    const location = this.getCurrentLocation()
    if (location) {
      selector.value = location.code
    }

    this.subscribedExternalSelectors.push(selector)

    this.getCurrentLocation()
  }

  /** @returns {ShippingLocation | undefined} */
  getLocationFromCookie () {
    const geoCookie = getCookie('fs-geo')

    if (!geoCookie) {
      return
    }

    const cookie = JSON.parse(geoCookie)
    return shippingCountries().find(country => country.code === cookie.value)
  }

  /** @returns {ShippingLocation | undefined} */
  getLocationFromUrl () {
    const region = new URL(window.location).searchParams.get('region')
    const location = shippingCountries().find(
      country => country.code === region,
    )

    return location
  }

  getCurrentLocation () {
    const locationFromCookie = this.getLocationFromCookie()

    if (locationFromCookie) {
      return locationFromCookie
    }

    const locationFromUrl = this.getLocationFromUrl()

    if (locationFromUrl) {
      return locationFromUrl
    }

    const selectValue = this.els.select.element.value
    return shippingCountries().find(country => {
      return country.code === selectValue
    })
  }

  async forceRedirect () {
    const selectedCountry = shippingCountries().filter(
      country => country.code === this.detectedIso2Code,
    )

    const storeLocalToCustomer = new URL(
      getRedirectUrl(
        selectedCountry[0].site,
        selectedCountry[0].code,
        selectedCountry[0].currency,
      ),
    )
    const currentStore = new URL(window.location)

    if (
      storeLocalToCustomer.host !== currentStore.host ||
      selectedCountry[0].currency !== window.Shopify.currency.active
    ) {
      window.location.href =
        storeLocalToCustomer.origin +
        window.location.pathname +
        storeLocalToCustomer.search
      setCookie(
        'fs-geo',
        JSON.stringify({
          value: selectedCountry[0].code,
          name: selectedCountry[0].name,
          site: selectedCountry[0].site,
          currency: selectedCountry[0].currency,
        }),
        14,
      )
      this.hideModal(true)
    } else {
      setCookie(
        'fs-geo',
        JSON.stringify({
          value: selectedCountry[0].code,
          name: selectedCountry[0].name,
          site: selectedCountry[0].site,
          currency: selectedCountry[0].currency,
        }),
        14,
      )
      this.hideModal()
    }
  }

  /** @param {Event} event */
  onExternalSelectChange (event) {
    const select = event.currentTarget

    const selectedCountry = shippingCountries().find(
      country => country.code === select.value,
    )

    const storeLocalToCustomer = new URL(
      getRedirectUrl(
        selectedCountry.site,
        selectedCountry.code,
        selectedCountry.currency,
      ),
    )
    const currentUrl = new URL(window.location)

    setCookie(
      'fs-geo',
      JSON.stringify({
        value: selectedCountry.code,
        name: selectedCountry.name,
        site: selectedCountry.site,
        currency: selectedCountry.currency,
      }),
      14,
    )

    if (currentUrl.searchParams.has('region')) {
      currentUrl.searchParams.delete('region')
    }

    window.location.href =
      storeLocalToCustomer.origin +
      window.location.pathname +
      storeLocalToCustomer.search
  }

  onSelectChange (event) {
    const currency = shippingCountries().filter(
      country => country.code === event.target.value,
    )[0].currency
    this.assignValuesToFormElements(event.target.value, currency)
  }

  onSubmission (event) {
    event.preventDefault()
    this.redirectCustomerOrSetCookie(this.els.select.element)
  }

  redirectCustomerOrSetCookie (element) {
    const selectedCountry = shippingCountries().filter(
      country => country.code === element.value,
    )

    const storeLocalToCustomer = new URL(
      getRedirectUrl(
        selectedCountry[0].site,
        selectedCountry[0].code,
        selectedCountry[0].currency,
      ),
    )
    const currentStore = new URL(window.location)

    if (
      storeLocalToCustomer.host !== currentStore.host ||
      selectedCountry[0].currency !== window.Shopify.currency.active
    ) {
      window.location.href =
        storeLocalToCustomer.origin +
        window.location.pathname +
        storeLocalToCustomer.search
      setCookie(
        'fs-geo',
        JSON.stringify({
          value: selectedCountry[0].code,
          name: selectedCountry[0].name,
          site: selectedCountry[0].site,
          currency: selectedCountry[0].currency,
        }),
        14,
      )
      this.hideModal(true)
    } else {
      setCookie(
        'fs-geo',
        JSON.stringify({
          value: selectedCountry[0].code,
          name: selectedCountry[0].name,
          site: selectedCountry[0].site,
          currency: selectedCountry[0].currency,
        }),
        14,
      )
      this.hideModal()
    }
  }

  checkIfSearchParamsExist () {
    return new URL(window.location).searchParams.get('region')
  }

  checkIfCookieIsSet () {
    return getCookie('fs-geo')
  }

  showModal () {
    this.setAttribute('aria-hidden', false)
    this.setAttribute('aria-expanded', true)
    document.body.classList.add('util-SiteOverflowed')

    this.els.submit.element.focus()
  }

  hideModal (isRedirect = false) {
    this.setAttribute('aria-hidden', true)
    this.setAttribute('aria-expanded', false)
    document.body.classList.remove('util-SiteOverflowed')

    if (!isRedirect) {
      revealCookieBanner()
    }
  }

  buildShippingOptions (selectEl) {
    const options = shippingCountries()

    options.forEach(option => {
      const currencySymbol = this.getCurrencySymbol(option.currency)
      const optionHTML = document.createElement('option')
      optionHTML.value = option.code
      optionHTML.text = `${option.name} ${currencySymbol}`
      selectEl.appendChild(optionHTML)
    })
  }

  getCurrencySymbol (currency) {
    if (currency === 'EUR') {
      return '€'
    } else if (currency === 'AED') {
      return 'AED'
    } else if (currency === 'SAR') {
      return 'SAR'
    } else {
      return '$'
    }
  }

  assignValuesToFormElements (selectValue, currencyValue) {
    this.els.select.element.value = selectValue
    this.els.currency.element.value = currencyValue

    this.subscribedExternalSelectors.forEach(selector => {
      selector.value = selectValue
    })
  }

  trapFocus () {
    const focusableEls = this.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
    )
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    this.addEventListener('keydown', e => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }
}

if (!customElements.get('shipping-location-modal')) {
  customElements.define('shipping-location-modal', ShippingLocationModal)
}
